import { useEffect, useState } from "react";
import { useSettingsController } from "../controller";
import { SettingsCard } from "./SettingsCard";
import { SettingsItem } from "./SettingsItem";

export const YardiIntegration = () => {
  const { currentSettings, updateSettings } = useSettingsController();
  const settings = currentSettings.yardi;

  const [editMode, setEditMode] = useState(false);
  const [yardiWebServiceUrl, setYardiWebServiceUrl] = useState("");
  const [yardiUsername, setYardiUsername] = useState("");
  const [yardiPassword, setYardiPassword] = useState("");
  const [yardiServerName, setYardiServerName] = useState("");
  const [yardiDatabase, setYardiDatabase] = useState("");

  useEffect(() => {
    setYardiWebServiceUrl(settings.webServiceUrl || "");
    setYardiUsername(settings.username || "");
    setYardiPassword(settings.password || "");
    setYardiServerName(settings.serverName || "");
    setYardiDatabase(settings.database || "");
  }, [
    settings.webServiceUrl,
    settings.username,
    settings.password,
    settings.serverName,
    settings.database
  ]);

  return (
    <SettingsCard
      title="Yardi Integration"
      editMode={editMode}
      setEditMode={setEditMode}
      onSave={() => {
        if (
          settings.webServiceUrl !== yardiWebServiceUrl ||
          settings.username !== yardiUsername ||
          settings.password !== yardiPassword ||
          settings.serverName !== yardiServerName ||
          settings.database !== yardiDatabase
        )
          updateSettings({
            yardiWebServiceUrl,
            yardiUsername,
            yardiPassword,
            yardiServerName,
            yardiDatabase
          });
      }}
    >
      <SettingsItem
        title="URL"
        value={yardiWebServiceUrl}
        editMode={editMode}
        onChange={setYardiWebServiceUrl}
      />
      <div className="my-6 border-b border-alpha-40" />
      <SettingsItem
        title="User Name"
        value={yardiUsername}
        editMode={editMode}
        onChange={setYardiUsername}
      />
      <div className="my-6 border-b border-alpha-40" />
      <SettingsItem
        title="Password"
        value={yardiPassword}
        editMode={editMode}
        onChange={setYardiPassword}
      />
      <div className="my-6 border-b border-alpha-40" />
      <SettingsItem
        title="Server Name"
        value={yardiServerName}
        editMode={editMode}
        onChange={setYardiServerName}
      />
      <div className="my-6 border-b border-alpha-40" />
      <SettingsItem
        title="Data Base"
        value={yardiDatabase}
        editMode={editMode}
        onChange={setYardiDatabase}
      />
    </SettingsCard>
  );
};
